import { render, staticRenderFns } from "./OrderRDItemInactiveEdit.vue?vue&type=template&id=f5f717c0&scoped=true"
import script from "./OrderRDItemInactiveEdit.vue?vue&type=script&lang=js"
export * from "./OrderRDItemInactiveEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderRDItemInactiveEdit.vue?vue&type=style&index=0&id=f5f717c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f717c0",
  null
  
)

export default component.exports